import { AutoComplete, Button, DatePicker, Input, Select, Tooltip, message } from "antd"
import "./detail.less"
import classNames from "classnames"
import { MeetingAttendee, MeetingMinute, MeetingOrganization, MeetingRecord, MeetingSummary } from "@/declare/interface/meeting"
import MeetingMinuteRecordDetail from "./switch/record-detail"
import MeetingMinuteSummaryDetail from "./switch/summary-detail"
import { useEffect, useRef, useState } from "react"
import { ReactComponent as CloseSvg } from "./icons/close.svg"
import { ReactComponent as ShowSvg } from "./icons/show.svg"
import { ReactComponent as ScrollLeftSvg } from "./icons/scorll-left.svg"
import { ReactComponent as ScrollRightSvg } from "./icons/scroll-right.svg"
import { ReactComponent as AddSvg } from "./icons/add.svg"
import { ReactComponent as DeleteSvg } from "./icons/delete.svg"
import MeetingMinuteTodoList from "./switch/todo-list"
import { addMeetingAttendee, addMeetingOrganization, addMeetingSummary, deleteMeetingAttendee, deleteMeetingOrganization, deleteMeetingSummary, findMeetingDetailById, submitMeetingMinutes, updateMeetingAttendee, updateMeetingMainDetail, updateMeetingOrganization } from "@/declare/api/meeting"
import dayjs from "dayjs"
import { Task } from "@/declare/interface/task"
import { getOrganizaitonList } from "@/declare/api/organization"
import { Organization } from "@/declare/interface/organization"
import { emitter, EMITTER_TYPE } from "@/store/mitt"
import { MeetingMinuteStatus } from "@/declare/enums/meeting-minute-status"
import { Project } from "@/declare/interface/project"
import { getProjects } from "@/declare/api/project"
import localStore from "@/store/local-store"
import { useLocation } from "react-router-dom"


interface IProps {
    meetingId: number,
    projectName: string //项目名称
    projectId: number,
    goToUrl: (url: string) => void
}

export default function MeetingMinuteDetail(props: IProps) {

    const { meetingId, projectId, goToUrl } = props;

    const location = useLocation();


    const [recordList, setRecordList] = useState<MeetingRecord[]>([])

    const [activeSwitchItem, setActiveSwitchItem] = useState<number>(1) // 下方展示的页面index

    const [orgList, setOrgList] = useState<MeetingOrganization[]>([]) // 参与的组织列表

    const [attendeeList, setAttendeeList] = useState<MeetingAttendee[]>([]) // 参与的人员列表

    const [taskList, setTaskList] = useState<Task[]>([]) // 待办事项-任务

    const [summaryList, setSummaryList] = useState<MeetingSummary[]>([]) // 总结列表

    const [meetingDetail, setMettingDetail] = useState<MeetingMinute>(null)

    const [sourceOrgOptions, setSourceOrgOptions] = useState<{ value: string, label: string }[]>([]) // 所有组织的option

    const [submitLoading, setSubmitLoading] = useState(false)

    const scrollableAttendeeRefs = useRef<(HTMLDivElement | null)[]>([]);

    const [hideHead, setHideHead] = useState<boolean>(false)

    const [projects, setProjects] = useState<Project[]>([]);
    const [selectProjectId, setSelectProjectId] = useState<number>(null);

    const generateData = () => {
        findMeetingDetailById(meetingId).then(res => {
            let resMeeting: MeetingMinute = res.data
            setMettingDetail(resMeeting)
            setAttendeeList([...resMeeting.attendeeList])
            setOrgList([...resMeeting.organizationList])
            setSummaryList([...resMeeting.summaryList])
            setRecordList([...resMeeting.recordList])
            setTaskList([...resMeeting.taskList])
        }).catch(e => {
            message.error("获取会议纪要详情失败")
        })
    }

    useEffect(() => {
        //根据路由中的查询参数，切换到对应的项目中
        // const searchValue = location.search;
        // let paramProjectId;
        // if (!!searchValue) {
        //     const regex = /\?projectId=(.*)/;
        //     paramProjectId = searchValue.match(regex)[1];
        // }
        // 使用 URLSearchParams 解析查询参数
        const queryParams = new URLSearchParams(location.search);
        // 获取参数 'a' 的值，如果没有则返回 null
        const paramProjectId = queryParams.get('projectId');
        if (paramProjectId != null && paramProjectId != "null") {
            const newUrl = window.location.pathname; // 不包含查询参数的新 URL
            window.history.replaceState({}, '', newUrl);
            setSelectProjectId(+paramProjectId);
            localStore.selectProjectId = +paramProjectId;
        } else {
            if (localStore.selectProjectId != null) {
                setSelectProjectId(localStore.selectProjectId);
            }
        }

        getProjects({ userId: localStore.userId }).then(res => {
            setProjects(res.data);
        })


        getOrganizaitonList().then(res => {
            let organizationList: Organization[] = res.data
            let midOrgOptions: { value: string, label: string }[] = []
            organizationList.forEach(organization => {
                midOrgOptions.push({ value: organization.name, label: organization.name })
            })
            setSourceOrgOptions(midOrgOptions)
        }).catch(e => {
            message.error("获取组织失败！")
        })
    }, [])

    useEffect(() => {
        if (!meetingId) {
            setMettingDetail({
                name: "会议纪要"
            })
            setAttendeeList([])
            setOrgList([])
        } else {
            generateData();
        }

    }, [meetingId])


    useEffect(() => {
        // 将会议状态设置为完成
        emitter.on(EMITTER_TYPE.MEETING_STATUS_UPDATE, (value) => {
            if (meetingDetail && meetingDetail.status != MeetingMinuteStatus.COMPLETED && meetingId) {
                generateData();
            }
        });
        return () => {
            emitter.off(EMITTER_TYPE.MEETING_STATUS_UPDATE);
        }
    }, [meetingId, meetingDetail])


    /**
     * 监听组织长度变化，动态添加ref来控制滚动
     */
    useEffect(() => {
        if (orgList.length > scrollableAttendeeRefs.current.length) {
            // 增加缺少的 refs
            const newRefs = Array(orgList.length - scrollableAttendeeRefs.current.length).fill(null);
            scrollableAttendeeRefs.current.push(...newRefs);
        }
    }, [orgList]);

    /**
     * 修改会议纪要主体内容
     * @param key 
     * @param value 
     * @returns 
     */
    const onChangeMeetingMainDetail = (key: string, value: any, needUpdateParent: boolean = false) => {
        meetingDetail[key] = value
        setMettingDetail({ ...meetingDetail })
        let updateData: MeetingMinute = {}
        updateData[key] = value
        if (!meetingId) return
        updateMeetingMainDetail(meetingId, updateData).then(res => {
        }).catch(e => {
            message.error("更新失败！")
        })
    }

    /**
     * 添加组织
     */
    const addMeetingOrg = () => {
        let addOrg: MeetingOrganization = {
            meetingId: meetingId,
        }
        if (meetingId) {
            addMeetingOrganization(meetingId, addOrg).then(res => {
                addOrg.id = res.data
                orgList.push(addOrg)
                setOrgList([...orgList])
            })
        } else {
            let maxIndex = getMaxIndex(orgList)
            addOrg.id = maxIndex
            orgList.push(addOrg)
            setOrgList([...orgList])
        }

    }

    /**
     * 修改组织名称
     * @param orgId 
     * @param name 
     * @returns 
     */
    const updateOrgName = (orgId: number, name: string) => {
        let orgIndex = orgList.findIndex(o => o.id == orgId)
        if (orgIndex < 0) return
        orgList[orgIndex].name = name
        setOrgList([...orgList])
        if (!meetingId) return
        updateMeetingOrganization(orgList[orgIndex].id, { name: name }).catch(e => {
            message.error("更新失败")
        })
    }

    /**
     * 添加参会人
     * @param orgId 
     */
    const addAttendee = (orgId: number) => {
        let addAtt: MeetingAttendee = {
            meetingId: meetingId,
            meetingOrgId: orgId,
        }
        if (meetingId) {
            addMeetingAttendee(meetingId, orgId, addAtt).then(res => {
                addAtt.id = res.data
                attendeeList.push(addAtt)
                setAttendeeList([...attendeeList])
            })
        } else {
            let maxIndex = getMaxIndex(attendeeList)
            addAtt.id = maxIndex
            attendeeList.push(addAtt)
            setAttendeeList([...attendeeList])
        }
    }

    /**
     * 更新参会人姓名
     * @param id 
     * @param value 
     * @returns 
     */
    const onChangeAttendeeName = (id: number, value: string) => {
        let index = attendeeList.findIndex(a => a.id == id)
        attendeeList[index].name = value
        setAttendeeList([...attendeeList])
        if (!meetingId) return
        updateMeetingAttendee(id, { name: value }).catch(e => {
            message.error("更新失败！")
        })
    }

    /**
     * 删除参会人
     * @param attId 
     */
    const onDeleteAttende = (attId: number) => {
        setAttendeeList(attendeeList.filter(a => a.id != attId))
        if (!meetingId) return
        deleteMeetingAttendee(attId).catch(e => {
            message.error("删除失败！")
        })
    }

    /**
     * 添加总结
     */
    const onClickAddSummary = () => {
        let addSum: MeetingSummary = {
            meetingId: meetingId
        }
        addMeetingSummary(meetingId, addSum).then(res => {
            addSum.id = res.data
            summaryList.push(addSum)
            setSummaryList([...summaryList])
        })
    }

    /**
     * 删除总结
     * @param summaryId 
     */
    const onClickDeleteSummary = (summaryId: number) => {
        setSummaryList([...summaryList.filter(p => p.id != summaryId)])
        deleteMeetingSummary(summaryId).catch(e => {
            message.error("删除失败！")
        })
    }

    const onClickDeleteOrg = (orgId: number, orgIndex: number) => {
        // 设置参与人
        setAttendeeList([...attendeeList.filter(a => a.meetingOrgId != orgId)])
        // 设置组织列表
        setOrgList([...orgList.filter(org => org.id != orgId)])
        deleteMeetingOrganization(orgId).catch(e => {
            message.error("删除失败！")
        })
    }

    /**
     * 平滑滚动
     * @param index 
     * @param direction 
     * @returns 
     */
    const smoothScroll = (index, direction) => {
        const div = scrollableAttendeeRefs?.current[index];
        if (!div) return;
        let targetScrollLeft = div.scrollLeft + direction * 65;
        const maxScrollLeft = div.scrollWidth - div.clientWidth;
        const minScrollLeft = 0;
        targetScrollLeft = Math.min(Math.max(targetScrollLeft, 0), maxScrollLeft);
        const scroll = () => {
            const currentScrollLeft = div.scrollLeft;
            const step = direction * 5;
            const tolerance = 1;
            if (
                Math.abs(currentScrollLeft - targetScrollLeft) > tolerance &&
                currentScrollLeft >= minScrollLeft &&
                currentScrollLeft <= maxScrollLeft
            ) {
                if (currentScrollLeft == minScrollLeft) {
                    if (direction > 0) {
                        div.scrollLeft += step;
                        requestAnimationFrame(scroll);
                    }
                } else if (currentScrollLeft == maxScrollLeft) {
                    if (direction < 0) {
                        div.scrollLeft += step;
                        requestAnimationFrame(scroll);
                    }
                } else {
                    div.scrollLeft += step;
                    requestAnimationFrame(scroll);
                }
            } else {
                div.scrollLeft = targetScrollLeft;
            }
        };
        // 启动平滑滚动
        requestAnimationFrame(scroll);
    };




    /**
     * 字段变化 实时修改
     * @param value 
     * @param field 
     */
    const onStringValueChange = (value: any) => {
        if (isNaN(+value)) {
            return;
        }
        setSelectProjectId(+value);
        localStore.selectProjectId = +value;
        if (+meetingId) {
            updateMeetingMainDetail(+meetingId, { projectId: +value });
        }

    }




    /**
     * 获取list中最大id
     * @param list 
     * @returns 
     */
    const getMaxIndex = (list: any) => {
        let maxIndex = 1
        for (let i = 0; i < list.length; i++) {
            if (list[i]?.id > maxIndex) {
                maxIndex = list[i].id
            }
        }
        return maxIndex + 1
    }

    /**
     * 提交会议纪要
     */
    const submit = () => {
        setSubmitLoading(true)
        let submitData: MeetingMinute = {
            startTime: new Date().getTime(),
            ...meetingDetail
        }
        let saveOrgList = [...orgList]
        for (let i = 0; i < saveOrgList.length; i++) {
            let attList = attendeeList.filter(att => att.meetingOrgId == saveOrgList[i].id)
            saveOrgList[i].attendeeList = attList
        }
        submitData.organizationList = saveOrgList
        let submitProjectId = selectProjectId ? selectProjectId : projectId;
        submitMeetingMinutes(submitProjectId, submitData).then(res => {
            console.log("res submitMeetingMinutes", res)
            if (res.status === 200 && props.goToUrl) {
                props.goToUrl(`meeting-record/${res.data}`)
            }

            setMettingDetail({
                name: "会议纪要"
            })
            setAttendeeList([])
            setOrgList([])
        }).catch(e => {
            message.error("提交失败！")
        }).finally(() => {
            setSubmitLoading(false)
        })
    }

    return (
        <div className="meeting-record-detail-main">
            <div className="title">
                <Input
                    value={meetingDetail?.name || ""}
                    variant="borderless"
                    className="title-input"
                    onChange={(e) => {
                        onChangeMeetingMainDetail("name", e.target.value)
                    }}
                    onBlur={(e) => {
                        onChangeMeetingMainDetail("name", e.target.value, true)
                    }}
                    onPressEnter={(e) => {
                        onChangeMeetingMainDetail("name", (e.target as any).value, true)
                    }}
                />
            </div>

            {!!meetingId && (
                <div className="hide-body">
                    <div className="switch-area">
                        <div onClick={() => { setActiveSwitchItem(0) }} className={classNames({
                            "switch-item": true,
                            "switch-item-active": activeSwitchItem == 0
                        })}>
                            参会人
                        </div>
                        <div onClick={() => { setActiveSwitchItem(1) }} className={classNames({
                            "switch-item": true,
                            "switch-item-active": activeSwitchItem == 1
                        })}>
                            记录
                        </div>
                        <div onClick={() => { setActiveSwitchItem(2) }} className={classNames({
                            "switch-item": true,
                            "switch-item-active": activeSwitchItem == 2
                        })}>
                            总结
                        </div>
                        <div onClick={() => { setActiveSwitchItem(3) }} className={classNames({
                            "switch-item": true,
                            "switch-item-active": activeSwitchItem == 3
                        })}>
                            待办事项
                        </div>
                    </div>
                    <>
                        {activeSwitchItem == 0 &&
                            <div className="info">
                                <div className="basic-infor">
                                    <DatePicker
                                        className="date-pick"
                                        size="small"
                                        placeholder="开始时间"
                                        value={meetingDetail?.startTime ? dayjs(meetingDetail.startTime) : null}
                                        onChange={(time) => {
                                            onChangeMeetingMainDetail("startTime", time?.valueOf() || null)
                                        }}
                                    />
                                    <div className="address-label">
                                        地址
                                    </div>
                                    <Input
                                        value={meetingDetail?.address || ""}
                                        onChange={(e) => { onChangeMeetingMainDetail("address", e.target.value) }}
                                        className="address-input"
                                        size="small"
                                    />
                                    <div className="link-label">
                                        链接
                                    </div>
                                    <Input
                                        className="link-input"
                                        size="small"
                                        value={meetingDetail?.linkStr || ""}
                                        onChange={(e) => { onChangeMeetingMainDetail("linkStr", e.target.value) }}
                                    />
                                </div>

                                <div className="basic-infor" style={{ marginTop: '4px' }}>
                                    {/* <div className="project-label">
                                        所属项目
                                    </div> */}
                                    <Select
                                        size="small"
                                        placeholder="请选择项目"
                                        style={{ width: '160px' }}
                                        filterOption={(input, option) =>
                                            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        onChange={(e) => onStringValueChange(e)}
                                        value={selectProjectId}
                                    >
                                        {projects?.map(item => (
                                            <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                                        ))}
                                    </Select>
                                </div>

                                <div className="involved">
                                    <div className="involved-title">
                                        参与组织<Tooltip title="添加组织">
                                            <AddSvg style={{ cursor: "pointer" }} onClick={addMeetingOrg} />
                                        </Tooltip>
                                    </div>
                                    <div className="org-area">
                                        {orgList?.map((org, index) => (
                                            <div className="org-attendees">
                                                <div className={classNames({
                                                    "org-item": true,
                                                    "org-item-last": index == orgList.length - 1
                                                })}>
                                                    <AutoComplete
                                                        size="small"
                                                        className="org-auto-complate"
                                                        variant="borderless"
                                                        value={org?.name}
                                                        searchValue={org?.name || ""}
                                                        options={sourceOrgOptions?.filter(sourceOrg => sourceOrg.value.toLowerCase().includes(org?.name?.toLowerCase() || ""))}
                                                        onChange={(value) => { updateOrgName(org.id, value) }}
                                                    />
                                                    <DeleteSvg onClick={() => { onClickDeleteOrg(org.id, index) }} className="auto-delete-svg" />
                                                </div>

                                                <div
                                                    ref={(el) => { scrollableAttendeeRefs.current[index] = el }}
                                                    className="attendees-list"
                                                >
                                                    {attendeeList.filter(att => att.meetingOrgId == org.id).map((att, index) => (
                                                        <div className="attendee-item">
                                                            <div className="item-name">
                                                                <Input
                                                                    style={{ padding: 0 }}
                                                                    autoFocus
                                                                    value={att.name}
                                                                    onChange={(e) => { onChangeAttendeeName(att.id, e.target.value) }}
                                                                    size="small"
                                                                    variant="borderless"
                                                                />
                                                                <CloseSvg onClick={() => onDeleteAttende(att.id)} className="attendee-close" />
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="add-area" onClick={() => { addAttendee(org.id) }} >
                                                        <Tooltip title="添加人员">
                                                            <AddSvg />
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        }
                        {activeSwitchItem == 1 &&
                            <MeetingMinuteRecordDetail
                                detail={meetingDetail}
                                setStatus={(status: number) => { setMettingDetail({ ...meetingDetail, status: status }) }}
                                status={meetingDetail?.status || 0}
                                attendeeList={attendeeList}
                                recordList={recordList}
                                setRecordList={setRecordList}
                            />
                        }
                        {activeSwitchItem == 2 &&
                            <MeetingMinuteSummaryDetail
                                onClickDelete={onClickDeleteSummary}
                                onClickAdd={onClickAddSummary}
                                summaryList={summaryList}
                            />
                        }
                        {activeSwitchItem == 3 &&
                            <MeetingMinuteTodoList
                                projectName={props.projectName}
                                todoList={taskList}
                                setTodoList={setTaskList}
                            />
                        }
                    </>
                </div>
            )}
            {meetingId == 0 && (
                <div className="submit-area">
                    <Button loading={submitLoading} className="btn" onClick={() => { submit() }}>
                        创建
                    </Button>
                </div>
            )}

        </div>
    )
}